// extracted by mini-css-extract-plugin
export default {"container":"CustomerPublicLayout_container__h5PdG","leftPanel":"CustomerPublicLayout_leftPanel__zneqz","rightPanel":"CustomerPublicLayout_rightPanel__O7H1G"};